import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { registerUser, clearAuthError, selectAuthLoading, selectAuthError, selectIsAuthenticated } from '../store/authSlice';
import GoogleLoginButton from '../components/auth/GoogleLoginButton';
import masterballSprite from '../assets/pokeballs/master-ball.png';
import './Auth.css';

function Signup() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const loading = useSelector(selectAuthLoading);
  const error = useSelector(selectAuthError);
  const isAuthenticated = useSelector(selectIsAuthenticated);

  const [form, setForm] = useState({ displayName: '', email: '', password: '', confirm: '' });
  const [localError, setLocalError] = useState(null);

  useEffect(() => {
    dispatch(clearAuthError());
  }, [dispatch]);

  useEffect(() => {
    if (isAuthenticated) navigate('/', { replace: true });
  }, [isAuthenticated, navigate]);

  const handleChange = (e) => {
    setLocalError(null);
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) {
      setLocalError('Passwords do not match');
      return;
    }
    if (form.password.length < 8) {
      setLocalError('Password must be at least 8 characters');
      return;
    }
    dispatch(registerUser({ email: form.email, password: form.password, displayName: form.displayName }));
  };

  const displayError = localError || error;

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-banner">
          <img src={masterballSprite} alt="Master Ball" className="auth-pokeball" />
          <h1 className="auth-title">Begin Your Journey</h1>
          <p className="auth-subtitle">Create an account to save teams and track progress</p>
        </div>

        <div className="auth-body">
          {displayError && <div className="auth-error">{displayError}</div>}

          <form className="auth-form" onSubmit={handleSubmit}>
            <div className="auth-field">
              <label htmlFor="displayName">Trainer Name</label>
              <input
                id="displayName"
                name="displayName"
                type="text"
                autoComplete="nickname"
                required
                value={form.displayName}
                onChange={handleChange}
                placeholder="Your trainer name"
              />
            </div>

            <div className="auth-field">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                value={form.email}
                onChange={handleChange}
                placeholder="you@example.com"
              />
            </div>

            <div className="auth-field">
              <label htmlFor="password">Password</label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="new-password"
                required
                value={form.password}
                onChange={handleChange}
                placeholder="At least 8 characters"
              />
            </div>

            <div className="auth-field">
              <label htmlFor="confirm">Confirm Password</label>
              <input
                id="confirm"
                name="confirm"
                type="password"
                autoComplete="new-password"
                required
                value={form.confirm}
                onChange={handleChange}
                placeholder="Repeat your password"
              />
            </div>

            <button type="submit" className="auth-submit" disabled={loading}>
              {loading ? 'Creating account...' : 'Create Account'}
            </button>
          </form>

          <div className="auth-divider"><span>or</span></div>

          <div className="auth-google">
            <GoogleLoginButton
              onSuccess={() => navigate('/', { replace: true })}
              onError={() => {}}
            />
          </div>

          <p className="auth-switch">
            Already have an account? <Link to="/login">Sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Signup;
